import { useState } from "react";

import { message } from "antd";

import useRequest from "./useRequest";

const usePassengers = () => {
  const [passengers, setPassengers] = useState([]);
  const [passenger, setPassenger] = useState();
  const [passengersByHotel, setPassengersByHotel] = useState([]);
  const [paymentMethods, setPaymentMethods] = useState([]);
  const [emailImports, setEmailImports] = useState({ results: [], count: 0 });
  const [emailImportDetail, setEmailImportDetail] = useState(null);
  const [sentEmails, setSentEmails] = useState({ results: [], count: 0 });

  const [loading, setLoading] = useState({
    get: false,
    post: false,
    put: false,
    delete: false,
  });

  const { request } = useRequest();

  async function deletePassenger(passengerId) {
    setLoading((prev) => ({ ...prev, delete: true }));

    return await request(
      "DELETE",
      `passengers/${passengerId}/`,
      (data) => {
        setLoading((prev) => ({ ...prev, delete: false }));
        return data;
      },
      (error) => {
        setLoading((prev) => ({ ...prev, delete: false }));
        return error;
      },
      {}
    );
  }

  async function getPassengers(params = {}) {
    setLoading((prev) => ({ ...prev, get: true }));
    return await request(
      "GET",
      "passengers/",
      (data) => {
        setPassengers(data);
        setLoading((prev) => ({ ...prev, get: false }));
        return data;
      },
      (error) => {
        setLoading((prev) => ({ ...prev, get: false }));
        return error;
      },
      {},
      params
    );
  }

  async function getPassengerDetail(passengerId) {
    return await request(
      "GET",
      `passengers/${passengerId}/`,
      (data) => {
        setPassenger(data);
        return data;
      },
      (error) => {
        return error;
      },
      {}
    );
  }

  async function createPassenger(body) {
    setLoading((prev) => ({ ...prev, post: true }));
    const data = await request(
      "POST",
      `passengers/`,
      (data) => {
        setLoading((prev) => ({ ...prev, post: false }));
        message.success("Venta creada correctamente");
        return data;
      },
      (error) => {
        message.error("Error al crear la venta");
        setLoading((prev) => ({ ...prev, post: false }));
        return error;
      },
      body
    );
    return data;
  }

  async function updatePassenger(body) {
    setLoading((prev) => ({ ...prev, post: true }));
    const data = await request(
      "PATCH",
      `passengers/${body.id}/`,
      (data) => {
        setLoading((prev) => ({ ...prev, post: false }));
        message.success("Acción realizada con éxito");
        return data;
      },
      (error) => {
        message.error("Error al editar al pasajero");
        setLoading((prev) => ({ ...prev, post: false }));
        return error;
      },
      body
    );
    return data;
  }

  async function getPaymentMethods(params = {}) {
    return await request(
      "GET",
      "payment-methods/",
      (data) => {
        setPaymentMethods(data.results);
        return data;
      },
      (error) => {
        return error;
      },
      {},
      params
    );
  }

  async function getPassengersByHotel(params = {}) {
    setLoading((prev) => ({ ...prev, get: true }));

    return await request(
      "GET",
      "passengers/grouped-by-hotel/",
      (data) => {
        data.forEach((passengerGroup) => {
          passengerGroup.id = Math.random().toString(36).substring(7);
        });

        setPassengersByHotel(data);
        setLoading((prev) => ({ ...prev, get: false }));
        return data;
      },
      (error) => {
        setLoading((prev) => ({ ...prev, get: false }));
        return error;
      },
      {},
      params
    );
  }

  async function createPayment(body = {}) {
    setLoading((prev) => ({ ...prev, post: true }));

    return await request(
      "POST",
      "passengers/payments/",
      (data) => {
        setLoading((prev) => ({ ...prev, post: false }));
        message.success("Acción realizada con éxito.");
        return data;
      },
      (error) => {
        setLoading((prev) => ({ ...prev, post: false }));
        return error;
      },
      body
    );
  }

  async function getSellerCommission(sellerId, date) {
    setLoading((prev) => ({ ...prev, post: true }));

    return await request(
      "GET",
      `passengers/seller-commission-pdf/${sellerId}/${date}/`,
      (data) => {
        setLoading((prev) => ({ ...prev, post: false }));
        message.success("Acción realizada con éxito.");
        return data;
      },
      (error) => {
        setLoading((prev) => ({ ...prev, post: false }));
        return error;
      }
    );
  }

  async function parseEmail(emailContent) {
    setLoading((prev) => ({ ...prev, post: true }));

    return await request(
      "POST",
      "passengers/parse-email/",
      (data) => {
        setLoading((prev) => ({ ...prev, post: false }));
        return data;
      },
      (error) => {
        setLoading((prev) => ({ ...prev, post: false }));
        message.error("Error al procesar el email");
        return error;
      },
      { email_content: emailContent }
    );
  }

  async function bulkCreatePassengers(passengersData) {
    setLoading((prev) => ({ ...prev, post: true }));

    return await request(
      "POST",
      "passengers/list/",
      (data) => {
        setLoading((prev) => ({ ...prev, post: false }));
        message.success(`${data.length} pasajeros creados correctamente`);
        return data;
      },
      (error) => {
        setLoading((prev) => ({ ...prev, post: false }));
        message.error("Error al crear los pasajeros");
        return error;
      },
      passengersData
    );
  }

  async function getEmailImports(params = {}) {
    setLoading((prev) => ({ ...prev, get: true }));

    return await request(
      "GET",
      "passengers/email-imports/",
      (data) => {
        setEmailImports(data);
        setLoading((prev) => ({ ...prev, get: false }));
        return data;
      },
      (error) => {
        setLoading((prev) => ({ ...prev, get: false }));
        return error;
      },
      {},
      params
    );
  }

  async function getEmailImportDetail(importId) {
    setLoading((prev) => ({ ...prev, get: true }));

    return await request(
      "GET",
      `passengers/email-imports/${importId}/`,
      (data) => {
        setEmailImportDetail(data);
        setLoading((prev) => ({ ...prev, get: false }));
        return data;
      },
      (error) => {
        setLoading((prev) => ({ ...prev, get: false }));
        return error;
      },
      {}
    );
  }

  async function getSentEmails(params = {}) {
    setLoading((prev) => ({ ...prev, get: true }));

    return await request(
      "GET",
      "passengers/sent-emails/",
      (data) => {
        setSentEmails(data);
        setLoading((prev) => ({ ...prev, get: false }));
        return data;
      },
      (error) => {
        setLoading((prev) => ({ ...prev, get: false }));
        return error;
      },
      {},
      params
    );
  }

  return {
    // passengers
    createPassenger,
    getPassengers,
    getPassengerDetail,
    updatePassenger,
    deletePassenger,
    setPassengers,
    getPassengersByHotel,
    setPassengersByHotel,
    getSellerCommission,
    passengersByHotel,
    passengers,
    setPassenger,
    passenger,

    // paymentMethods
    getPaymentMethods,
    setPaymentMethods,
    paymentMethods,

    // payment
    createPayment,

    // email parsing
    parseEmail,
    bulkCreatePassengers,

    // email imports
    getEmailImports,
    getEmailImportDetail,
    emailImports,
    emailImportDetail,
    setEmailImportDetail,

    // sent emails
    getSentEmails,
    sentEmails,

    loading,
  };
};

export default usePassengers;
